import { render, staticRenderFns } from "./mailbox.vue?vue&type=template&id=e22acbac&scoped=true"
import script from "./mailbox.vue?vue&type=script&lang=js"
export * from "./mailbox.vue?vue&type=script&lang=js"
import style0 from "./mailbox.vue?vue&type=style&index=0&id=e22acbac&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e22acbac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\App_php\\cqjtdx\\cqjtdx_student\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e22acbac')) {
      api.createRecord('e22acbac', component.options)
    } else {
      api.reload('e22acbac', component.options)
    }
    module.hot.accept("./mailbox.vue?vue&type=template&id=e22acbac&scoped=true", function () {
      api.rerender('e22acbac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/userCenter/mailbox.vue"
export default component.exports